import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '@ca/core/services';

export interface CardVideo {
    imageSrc: string;
    videoUrl: string;
}

@Component({
    selector: 'ca-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class CardComponent {
    @Input() title: string;
    @Input() imageSrc: string;
    @Input() videoUrl?: string;
    @Input() routeLink?: string;
    @Input() buttonText: string;
    @Input() description?: string;
    @Input() openInNewPage: boolean = false;

    /**
     * Add a custom class to the call to action element
     */
    @Input() callToActionClass?: string;

    constructor(
        private router: Router,
        private windowRef: WindowRef,
    ) {}

    openLink(): void {
        if (this.openInNewPage === true) {
            const windowReference = this.windowRef.nativeWindow.open(this.routeLink);
            if (windowReference != null) {
                windowReference.focus();
            }
        } else if (this.routeLink != null) {
            this.router.navigateByUrl(this.routeLink);
        }
    }

    shouldShowContentArea(): boolean {
        return this.description != null || this.title != null;
    }
}
